import { render, staticRenderFns } from "./TabHeader.vue?vue&type=template&id=3be93120&scoped=true"
import script from "./TabHeader.vue?vue&type=script&lang=js"
export * from "./TabHeader.vue?vue&type=script&lang=js"
import style0 from "./TabHeader.vue?vue&type=style&index=0&id=3be93120&prod&lang=less&scoped=true"
import style1 from "./TabHeader.vue?vue&type=style&index=1&id=3be93120&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be93120",
  null
  
)

export default component.exports